var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-header-container"},[_c('img',{staticClass:"logo largeLogo",attrs:{"src":"/images/dark-logo.svg","alt":"Leland Little Auctions"},on:{"click":_vm.exit}}),_vm._v(" "),_c('label',[_vm._v("AUCTION ITEM CHECKOUT")])])
}
var staticRenderFns = []

export { render, staticRenderFns }